export const getTheme = theme => {
  return require("./".concat(theme, ".module.css"));
};
export const getRoundButtonTheme = theme => {
  return require("./".concat(theme, ".module.css"));
};